import React, { useEffect, useState } from "react";
import { History } from "lucide-react";
import { api, fmtDate } from "@/lib/api";

const FIELD = { baslangic: "Başlangıç", bitis: "Bitiş", gun_sayisi: "Gün", tur: "Tür", aciklama: "Açıklama", is_gunu_modu: "İş günü modu", personnel_id: "Personel" };
const TUR = { yillik: "Yıllık İzin", ucretli_izin: "Ücretli İzin", ucretsiz_izin: "Ücretsiz İzin", rapor: "Rapor" };
const DOT = { create: "bg-indigo-500", update: "bg-slate-500", delete: "bg-rose-500" };

const fmtVal = (k, v) => {
  if (v == null || v === "") return "—";
  if (k === "baslangic" || k === "bitis") return fmtDate(v);
  if (k === "tur") return TUR[v] || v;
  if (k === "is_gunu_modu") return v ? "Evet" : "Hayır";
  if (k === "personnel_id") return "değişti";
  return String(v);
};
const fmtAt = (iso) => { try { return new Date(iso).toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }); } catch { return iso; } };

export function LeaveHistory({ leaveId, refreshKey }) {
  const [events, setEvents] = useState(null);
  useEffect(() => {
    api.get(`/annual-leave/${leaveId}/history`).then((r) => setEvents(r.data.events || [])).catch(() => setEvents([]));
  }, [leaveId, refreshKey]);
  if (events === null) return <div className="text-[11px] text-slate-400">Geçmiş yükleniyor...</div>;
  return (
    <div data-testid="leave-history">
      <div className="text-[10px] font-bold uppercase tracking-wider text-slate-500 flex items-center gap-1 mb-1"><History size={11} /> Kayıt Geçmişi ({events.length})</div>
      <ol className="space-y-1.5 max-h-48 overflow-y-auto pr-1">
        {events.map((e, i) => (
          <li key={i} className="relative pl-4 text-[11px]" data-testid={`leave-history-event-${i}`}>
            <span className={`absolute left-0 top-1 w-2 h-2 rounded-full ${DOT[e.action] || "bg-slate-400"}`} />
            <div><span className="font-bold text-slate-800">{e.label || e.action}</span> <span className="text-slate-500">· {fmtAt(e.at)}</span></div>
            <div className="text-slate-600">{e.actor_email || "—"}</div>
            {e.action === "update" && e.after && !e.after.belge && (
              <ul className="text-slate-700">
                {Object.keys(e.after).filter((k) => FIELD[k]).map((k) => (
                  <li key={k}><span className="font-semibold">{FIELD[k]}:</span> <span className="line-through opacity-60">{fmtVal(k, e.before?.[k])}</span> → <span className="font-semibold">{fmtVal(k, e.after[k])}</span></li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ol>
    </div>
  );
}
